import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Dimmer,
  Grid,
  Loader,
  Menu,
  Button,
  Table,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { decodeSearch, encodeSearch } from '../../utils/url';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';

import PageNav from '../../components/PageNav';
import NavBar from '../../components/NavBar';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import Timestamp from '../../components/Timestamp';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { SelectList } from '../../components/Filters';

class CustomerList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isDeveloper: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })

  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = props.data || [];
    const count = props.count;
    const limit = props.limit || 10;
    const offset = props.offset || 0;
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const advanceFilter = false;
    const projectBranchOwnerID = query.projectBranchOwnerID || '';
    const showBookingCount = query.showBookingCount || true;

    return {
      data,
      loading,
      count,
      limit,
      offset,
      search,
      advanceFilter,
      currentPage,
      projectBranchOwnerID,
      showBookingCount,
    };
  }

  constructor(props) {
    super(props);
    const state = CustomerList.getPropsToState(props);
    this.state = {
      ...state,
      branches: [],
      businessUnitFilter: false,
    };
  }

  componentWillMount() {
    if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
      this.fetchBranches(false);
    }
  }

  componentWillReceiveProps(nextProps) {
    const state = CustomerList.getPropsToState(nextProps);
    this.setState({ ...state }, () => {
      const { query } = nextProps.location;
      if (
          (query.projectBranchOwnerID && query.projectBranchOwnerID.length > 0)
        ) {
        this.setState({
          advanceFilter: true,
        });
      }
    });
  }

  getBranchShortName = (id, arr) => {
    const valueName = arr.find(vn => vn.id === id);
    if (valueName && valueName.name) {
      return valueName.name;
    }
    return '';
  }
  setCustomers(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchBranches(silent = false) {
    if (!silent) await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/search/company_branches/?page=all&isExternal=false`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      if (!silent) await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const branches = await res.json();
      await this.setComponentState({
        branches: branches ? branches.map((ul) => {
          const branch = { id: ul.id, text: ul.shortName, name: ul.shortName, value: ul.id.toString(), description: ul.isExternal ? 'Agency' : '' };
          return branch;
        }) : [],
      });
    }
    if (!silent) await this.setLoading(false);
  }

  hasAccess(check = false) {
    if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
      return true;
    }
    return check;
  }

  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }

  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }

  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }

  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.setState({
      [queryName]: value,
      businessUnitFilter: false,
    });
    this.replaceQuery(query, true);
  }

  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }

  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    store.dispatch(replace(`/customers/?${encodeSearch(query)}`));
  }
  sortItems = [
    {
      text: 'Date Created Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'customer_detail.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Created Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'customer_detail.created_at',
      sortDirection: 'desc',
    },
    {
      text: 'Name Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'customer_detail.name',
      sortDirection: 'asc',
    },
    {
      text: 'Name Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'customer_detail.name',
      sortDirection: 'desc',
    },
  ];
  render() {
    const { branches } = this.state;
    const { store } = this.context;
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Customers')}
          rightNav={
            <Menu.Item fitted>
              <Button
                primary
                icon="add"
                content={t('Customer')}
                disabled={this.state.loading}
                onClick={() => store.dispatch(push('/customers/new/'))}
              />
            </Menu.Item>
          }
        />
        <Grid verticalAlign="middle">
          <Grid.Row>
            <Grid.Column width={16}>
              <SearchFilter
                advanceFilter={this.state.advanceFilter}
                isLoading={this.state.loading}
                onChange={this.handleFilterOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                setAdvanceFilter={this.handleSetAdvanceFilter}
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.data.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <SortButton
                    floated="right"
                    loading={this.state.loading}
                    items={this.sortItems}
                    onSort={this.handleSortData}
                  />
                )}
              >
                {
                  this.hasAccess() && (
                    <SelectList
                      filterName="projectBranchOwnerID"
                      headerText={null}
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={this.state.branches}
                      placeholder={t('Select Business Unit')}
                      value={this.state.projectBranchOwnerID}
                      hasSearch
                      onFocus={this.state.businessUnitFilter}
                    />
                  )
                }
              </SearchFilter>
            </Grid.Column>
          </Grid.Row>

          {/* List Data */}
          <Grid.Row style={{ paddingTop: '0px' }}>
            <Grid.Column>
              <Dimmer
                inverted style={{ zIndex: 20 }}
                active={this.state.loading && this.state.data.length > 0}
              >
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Table
                celled
                compact
              >
                <Table.Header className="mobile-hide">
                  <Table.Row>
                    <Table.HeaderCell width="4">{t('Name')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Mobile')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Email')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Created Date')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Created By')}</Table.HeaderCell>
                    {this.hasAccess() && <Table.HeaderCell>{t('Business Unit')}</Table.HeaderCell>}
                    <Table.HeaderCell>{t('Total Bookings')}</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    this.state.data.length > 0 ?
                      this.state.data.filter(data => data.customerDetail.name !== '').map((data, idx) => (
                        <Table.Row
                          key={idx}
                        >
                          <Table.Cell width="4">
                            <Link to={`/customers/${data.id}/`}>
                              {data.customerDetail.title === 'Not Applicable' ? '' : t(data.customerDetail.title, { ns: TRANSLATION_FILES.constants })} {data.customerDetail.name}
                            </Link>
                          </Table.Cell>
                          <Table.Cell>
                            +{data.customerDetail.mobilePrefix}{data.customerDetail.mobile}
                          </Table.Cell>
                          <Table.Cell textAlign={data.customerDetail.email.length > 0 ? 'left' : 'center'}>
                            {
                              data.customerDetail.email.length > 0 ?
                                data.customerDetail.email
                                : <span>-</span>
                            }
                          </Table.Cell>
                          <Table.Cell><Timestamp format="DD/MM/YY hh:mm a" timestamp={data.createdAt} /></Table.Cell>
                          <Table.Cell>
                            {
                              (this.hasAccess(this.props.auth.isBranchLeader) &&
                                data.maUserAffiliateID > 0) && (
                                  this.props.auth.isBranchLeader ?
                                    data.maUserAffiliateName :
                                    <Link to={`/users/${data.maUserAffiliateID}/`}>
                                      {data.maUserAffiliateName}
                                    </Link>
                              )
                            }
                          </Table.Cell>
                          {this.hasAccess() && (
                            <Table.Cell>
                              <Link to={`/business_units/${data.maOwnerCompanyBranchID}/`}>
                                {
                                  this.getBranchShortName(
                                    data.maOwnerCompanyBranchID,
                                    branches,
                                  )
                                }
                              </Link>
                            </Table.Cell>
                          )}
                          <Table.Cell textAlign="center" content={data.totalBooking} />
                        </Table.Row>
                      )) : <Table.Row>
                        <Table.Cell colSpan="7" textAlign="center">
                          {
                            this.state.loading ?
                              <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                            : <p>{t('No customer found')}.</p>
                          }
                        </Table.Cell>
                      </Table.Row>
                  }
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <PageNav
                upward
                currentPage={this.state.currentPage}
                count={this.state.count}
                limit={this.state.limit}
                offset={this.state.offset}
                dataSize={this.state.data.length}
                loading={this.state.loading}
                onChange={this.handleChangePage}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(CustomerList.mapStateToProps)(CustomerList));



// WEBPACK FOOTER //
// ./src/containers/Customers/List.jsx